export { ProviderDetailsView } from './ProviderDetailsView';
